// extracted by mini-css-extract-plugin
export default {"count":"legislative_text_snippet-module__count--2Yb4E"};